import { useEffect } from "react";

import { consumeAccountCreationCallback } from "@/lib/analytics";

export function useConsumeAccountCreationCallback(userId: string | null) {
  useEffect(() => consumeAccountCreationCallback(userId), [userId]);
}
